import { render, staticRenderFns } from "./SkillForm.vue?vue&type=template&id=00aa6ffe&"
import script from "./SkillForm.vue?vue&type=script&lang=js&"
export * from "./SkillForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports